const inr = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const inr0 = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });

export const money = (value: number | string | null | undefined): string =>
  `₹${inr.format(Number(value ?? 0))}`;

export const money0 = (value: number | string | null | undefined): string =>
  `₹${inr0.format(Number(value ?? 0))}`;

/** ₹1.2L / ₹3.4Cr for tiles where the exact paisa is noise. */
export function compact(value: number | string | null | undefined): string {
  const n = Number(value ?? 0);
  if (Math.abs(n) >= 1e7) return `₹${(n / 1e7).toFixed(2)}Cr`;
  if (Math.abs(n) >= 1e5) return `₹${(n / 1e5).toFixed(2)}L`;
  if (Math.abs(n) >= 1e3) return `₹${(n / 1e3).toFixed(1)}K`;
  return `₹${inr0.format(n)}`;
}

export const pct = (value: number | null | undefined): string => `${(Number(value) || 0).toFixed(1)}%`;

export const qty = (value: number | null | undefined, unit?: string): string => {
  const n = Number(value ?? 0);
  const text = Number.isInteger(n) ? String(n) : n.toFixed(3).replace(/0+$/, '').replace(/\.$/, '');
  return unit ? `${text} ${unitLabel(unit)}` : text;
};

export const unitLabel = (unit: string): string =>
  ({ KG: 'kg', LITRE: 'L', PIECE: 'pc', GRAM: 'g', ML: 'ml' })[unit] ?? unit.toLowerCase();

const dateFmt = new Intl.DateTimeFormat('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
const shortFmt = new Intl.DateTimeFormat('en-IN', { day: '2-digit', month: 'short' });
const timeFmt = new Intl.DateTimeFormat('en-IN', { hour: '2-digit', minute: '2-digit' });

const parse = (value: string | Date | null | undefined): Date | null => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const date = (value: string | Date | null | undefined): string => {
  const d = parse(value);
  return d ? dateFmt.format(d) : '—';
};
export const dateShort = (value: string | Date | null | undefined): string => {
  const d = parse(value);
  return d ? shortFmt.format(d) : '—';
};
export const time = (value: string | Date | null | undefined): string => {
  const d = parse(value);
  return d ? timeFmt.format(d) : '—';
};
export const dateTime = (value: string | Date | null | undefined): string => {
  const d = parse(value);
  return d ? `${shortFmt.format(d)}, ${timeFmt.format(d)}` : '—';
};

export const today = (): string => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
export const thisMonth = (): string => today().slice(0, 7);

export const titleCase = (value: string): string =>
  value
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const initials = (name: string): string =>
  name
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
